
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 0C3.279 0 .25 3.05.25 6.799c0 5.327 6.115 10.828 6.376 11.059a.562.562 0 00.748 0c.26-.232 6.376-5.732 6.376-11.06C13.75 3.05 10.722 0 7 0zm0 10.5a3.754 3.754 0 01-3.75-3.75A3.754 3.754 0 017 3a3.754 3.754 0 013.75 3.75A3.754 3.754 0 017 10.5z","fill":"#fff"}})])
          )
        }
      }
    